<ng-container>

  <div class="modal-body printPreview" [hidden]="hidePrintExport">
    <jt-modal-page [defaultHide]="'true'">
      <app-jt-modal-hor-form [formConfig]="modalConfig">
        <form-actions data-testid="form-action-buttons">
          <button aria-hidden="true" data-testid="btn-export-to-excel" id="btnExporttoExcel" attr.data-file-name="{{fileName}}" onclick="exportToExcel()" class="hidden btnExporttoExcel btn btn-primary form-group" type="button">{{ 'Common.ExportToExcel' | translate }}</button>
          <button class="btn btn-primary form-group btn_exportWord" data-testid="btn-export-to-word" onclick="exportToWord()">
            {{ 'Common.ExportToWord' | translate }}
          </button>
          <button class="btn btn-success form-group btn_print" data-testid="btn-print" printSectionId="print-section" onclick="window.print();">
            {{ 'Common.Print' | translate }}
          </button>
          <button class="btn btn-danger form-group btn_close" data-testid="btn-exit" (click)="close()" type="button">
            {{'Common.Close' | translate}}
          </button>
        </form-actions>
        <form-body>
          <div class="col-md-12" id="print-section">
            <div class="table-responsive mt-2">
              <table class="table datatablePrint table2excel" border="1" data-tableName="Test Table 2" id="exportTable" data-testid="tbl-export">
                <thead data-testid="thead-export">
                  <tr>
                    <ng-container *ngFor="let field of pageFields;index as j">
                      <th [attr.data-testid]="'th-'+ field.columnName" style="border-color:#ccc !important; border-collapse:collapse !important; border:1px solid #ccc !important;text-align:left !important;margin-right:20px;">
                        <span *ngIf="j === 0"><b>#</b></span>
                        <span *ngIf="field.jT7Localization !== null && field.jT7Localization !== ''">
                          {{ field.jT7Localization |translate }}
                        </span>
                        <span *ngIf="j > 0">
                          <b>
                            <span *ngIf="field.jT7Localization === null || field.jT7Localization === ''">
                              {{ field.columnHeader }}
                            </span>
                          </b>
                        </span>
                        <span *ngIf="j > 0" class="sort">
                        </span>
                      </th>
                    </ng-container>
                  </tr>
                </thead>
                <tbody data-testid="tbody-export">
                  <ng-container *ngFor="let data of listOfData;index as i;">
                    <tr>
                      <ng-container *ngFor="let field of pageFields;">
                        <ng-container *ngFor="let propertyName of properties;">
                          <ng-container *ngIf="field.columnName.toLowerCase() === propertyName.toLowerCase();">

                            <td *ngIf="field.isSystemRefId>0" style="border-color:#ccc !important; border-collapse:collapse !important; border:1px solid #ccc !important">
                              {{i + 1}}
                            </td>

                            <td *ngIf="field.isSystemRefId === 0 && field.columnName !== 'AgencyData'" style="border-color:#ccc !important; border-collapse:collapse !important; border:1px solid #ccc !important" [innerHTML]='[field.columnType?.toLowerCase() === "date" ? (data[propertyName] | date): field.columnType?.toLowerCase() === "time" ? (data[propertyName] | date : "HH:mm") : ((field.columnName==="VisibleTo")? ("External:"+data.VisibleTo.external +",Internal:"+data.VisibleTo.internal+",Agency:"+data.VisibleTo.agency) :  data[propertyName])] '>
                            </td>
                            <td *ngIf="field.isSystemRefId === 0 && field.columnName === 'AgencyData'">
                              <span *ngIf="data.AgencyData.result === 'Correct'"> <app-svg-icon [type]="'complete_check'" [className]="'svg-completed'"> </app-svg-icon></span>
                              <span class="Incorrect" *ngIf="data.AgencyData.result === 'Incorrect'"> <app-svg-icon [type]="'Cross'" [className]="'svg-completed'"> </app-svg-icon></span>
                            </td>

                          </ng-container>
                        </ng-container>
                      </ng-container>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>
        </form-body>
      </app-jt-modal-hor-form>
    </jt-modal-page>
  </div>

  <app-excel-export-modal></app-excel-export-modal>


  </ng-container>



